// 🚨 This file has not been broken down into lazy-loaded, JIT files. It is low priority to do so as this is not a part of the the critical user ecommerce path.
window.cpap.onDocumentReady(() => {
  window.scheduler.postTask(
    () => {
      const loadDeferredUtiltityFunctions = (callback) => {
        window.cpap.dynamicallyLoadScript(
          window.cpap.cdnSources.cpapJitUtilitiesJs,
          callback ? { onload: callback } : undefined
        );
      };

      // Preload the JIT utility functions
      window.scheduler.postTask(() => loadDeferredUtiltityFunctions(), { priority: 'background' });

      toggleHeaderLogoOrientation();
      document.querySelector('.cpap__page-loader--on-page-load')?.classList.add('d-none');

      const debouncedtoggleHeaderLogoOrientation = window.cpap.debounce(() => {
        toggleHeaderLogoOrientation();

        const progressSpan = document.getElementById('quiz-progress');
        const currentProgress = parseInt(progressSpan.textContent, 10);
        updateProgressBar(currentProgress);
      }, 250);

      window.addEventListener('resize', debouncedtoggleHeaderLogoOrientation, { passive: true });

      document.querySelector('.quiz-steps').addEventListener('change', (event) => {
        const selectElement = event.target.closest('select');

        if (!selectElement) return;

        // Remove error tips
        const errorTipsElement = selectElement
          .closest('.product-option')
          ?.querySelector('.error-tips');
        if (errorTipsElement) {
          errorTipsElement.classList.remove('is-show');
        }

        // Add click state
        selectElement.closest('.product-option')?.classList.add('is-click');

        // Get all select elements in the current card
        const cardBottom = selectElement.closest('.cpap__product-comparisons__card-bottom');
        const selectElements = cardBottom?.querySelectorAll('select');

        if (!selectElements?.length) {
          return;
        }

        // Extract select names and values
        const selectData = Array.from(selectElements).reduce((acc, select, index) => {
          const name = select.getAttribute('name');
          const value = select.value;

          acc[`select_name_${index + 1}`] = name || '';
          acc[`select_val_${index + 1}`] = value || '';

          return acc;
        }, {});

        // Find matching variant
        const varsValueElements = cardBottom.querySelectorAll('.vars-value div');

        varsValueElements.forEach((varElement) => {
          const dataSize = varElement.getAttribute(`data-${selectData.select_name_1}`) || '';
          const dataColor = selectData.select_name_2
            ? varElement.getAttribute(`data-${selectData.select_name_2}`) || ''
            : '';
          const data3 = selectData.select_name_3
            ? varElement.getAttribute(`data-${selectData.select_name_3}`) || ''
            : '';

          const dataId = varElement.getAttribute('data-id');
          const dataSoldOut = varElement.getAttribute('data-soldout');
          const dataPrescription = varElement.getAttribute('data-prescription');

          let dataPrice = parseFloat(varElement.getAttribute('data-price')) / 100;
          dataPrice = dataPrice.toFixed(2);

          // Check if variant matches selected options
          const matches =
            dataSize === selectData.select_val_1 &&
            (!selectData.select_val_2 || dataColor === selectData.select_val_2) &&
            (!selectData.select_val_3 || data3 === selectData.select_val_3);

          if (matches) {
            const addToCartButton = varElement.closest(
              '.cpap__product-comparisons__add-to-cart-button'
            );
            const primaryButton = addToCartButton.querySelector('.btn-primary');
            const btnTextElement = addToCartButton.querySelector('.btn-text');
            const btnPriceElement = addToCartButton.querySelector('.btn-price');

            if (dataSoldOut === 'false') {
              // Available product
              primaryButton.disabled = false;
              btnTextElement.textContent = 'Add to Cart';
              btnPriceElement.textContent = `$${dataPrice}`;

              primaryButton.setAttribute(
                'onclick',
                `window.cpap.quiz.quizProductClickHandler(this, ${dataId}, '$${dataPrice}', '${dataPrescription}')`
              );
            } else {
              // Out of stock product
              setTimeout(() => {
                const buttonUrl = varElement.closest('.product-card').getAttribute('href');

                primaryButton.disabled = true;
                btnTextElement.textContent = 'Out of Stock';
              }, 400);
            }
          }
        });
      });

      let bmi;
      let heightFeet, heightInches, weightPounds, age, neck;
      let bmiCount = 0;

      document.getElementById('btn-quiz').addEventListener('click', () => {
        loadDeferredUtiltityFunctions(() => {
          window.cpap.visualEffects.fadeOut('.start-quiz-main');

          window.cpap.visualEffects.fadeIn('.tabbing-content[data-type="bmiform"]');
          setTimeout(() => {
            window.cpap.visualEffects.fadeIn('.quiz-steps');
          }, 500);
        });
      });

      let stepCount =
        document.querySelectorAll('.tabbing-content[data-type="question"]').length +
        document.querySelectorAll('.tabbing-content[data-type="bmiform"]').length;
      if (stepCount >= 1) {
        let quizBannerText = 'Answer these ' + stepCount + ' short questions to see the results';
        document.querySelector('.start-quiz-content h3').textContent = quizBannerText;
      } else {
        let quizBannerText = 'To Be Determined';
        document.querySelector('.start-quiz-content h3').textContent = quizBannerText;
      }

      document.querySelectorAll('.tabbing-main .tabbing-content').forEach((element, index) => {
        if (index !== 0) element.classList.add('cpap__fadeable--hidden');
      });

      document.getElementById('tabbing-prev').addEventListener('click', () => {
        let current = window.cpap.getFirstVisibleElement('.tabbing-main .tabbing-content');
        let prev = current.previousElementSibling;

        if (prev) {
          loadDeferredUtiltityFunctions(() => {
            window.cpap.visualEffects.fadeOut(current);

            setTimeout(() => {
              window.cpap.visualEffects.fadeIn(prev);

              if (prev.dataset.type === 'form') {
                window.cpap.visualEffects.fadeOut(prev);
                window.cpap.visualEffects.fadeIn(prev.previousElementSibling);
                setTimeout(() => {
                  document
                    .querySelector('.header__icon--cart svg path')
                    .setAttribute('fill', '#2e2e2e');
                }, 500);
                window.cpap.visualEffects.fadeOut('.header-caret-icon');
              } else {
                document.getElementById('tabbing-next').classList.remove('cpap__fadeable--hidden');
                window.cpap.visualEffects.fadeIn('.header-caret-icon');
              }
            }, 250);
          });
        }

        if (prev && prev.dataset.type === 'bmiform') {
          document.getElementById('tabbing-prev').classList.add('cpap__fadeable--hidden');
        }

        if (!document.querySelector('.error-msg').classList.contains('hidden')) {
          document.querySelector('.error-msg').classList.add('hidden');
        }

        calculateProgress();
      });

      document.getElementById('tabbing-next').addEventListener('click', () => {
        let current = window.cpap.getFirstVisibleElement('.tabbing-main .tabbing-content');
        let type = current.getAttribute('data-type');
        let validate = type === 'question';
        let next = current.nextElementSibling;

        if (type === 'bmiform') {
          if (bmi && bmiFormValuesChanged()) {
            if (document.querySelector('#bmi-form-body .bmi-result')) {
              document.querySelector('#bmi-form-body .bmi-result').innerHTML = '';
            }
            document
              .getElementById('bmi-form-body')
              .insertAdjacentHTML(
                'beforeend',
                '<div class="form-field bmi-result mt-4" style="color: var(--cpap-text-error-red);">Values have changed. Please submit the form again.</div>'
              );
            styleFormValidation(false);
            return false;
          }
        }

        loadDeferredUtiltityFunctions(() => {
          if (next && !validate && bmi) {
            document.getElementById('tabbing-prev').classList.remove('cpap__fadeable--hidden');
            styleFormValidation(true);
            window.cpap.visualEffects.fadeOut(current);
            setTimeout(() => {
              window.cpap.visualEffects.fadeIn(next);
            }, 250);
          } else if (next && validate) {
            let activetab = current.querySelectorAll('.choose-block.active').length;
            if (activetab && bmi) {
              styleFormValidation(true);
              window.cpap.visualEffects.fadeOut(current);
              setTimeout(() => {
                window.cpap.visualEffects.fadeIn(next);
              }, 250);
            } else {
              document.querySelector('.error-msg').classList.remove('hidden');
            }
          } else {
            document
              .getElementById('bmi-form-body')
              .insertAdjacentHTML(
                'beforeend',
                '<div class="form-field bmi-result mt-4" style="color: var(--cpap-text-error-red);">Please complete all fields and submit</div>'
              );
            styleFormValidation(false);
          }

          if (next && next.getAttribute('data-type') === 'form') {
            loadDeferredUtiltityFunctions(() => {
              let activetab = current.querySelectorAll('.choose-block.active').length;
              if (activetab) {
                window.cpap.visualEffects.fadeOut('.header-caret-icon');
                document.getElementById('tabbing-next').classList.add('cpap__fadeable--hidden');
                document.getElementById('subscription-submission').click();
              } else {
                document.querySelector('.error-msg').classList.remove('hidden');
              }
            });
          }

          if (next && next.getAttribute('data-type') === 'result') {
            setTimeout(() => {
              document
                .querySelector('.header__icon--cart svg path')
                .setAttribute('fill', 'var(--cpap-primary-white');
            }, 750);
          }

          calculateProgress();
        });
      });

      function validateBmiForm() {
        if (document.querySelector('#bmi-form-body .bmi-result')) {
          document.querySelector('#bmi-form-body .bmi-result').innerHTML = '';
        }
        let birthSexStr = document.querySelector('.form-select[name="birth_sex"]').value?.trim();
        let heightFeetStr = document.querySelector('.form-input[name="height_feet"]').value?.trim();
        let heightInchesStr = document
          .querySelector('.form-input[name="height_inches"]')
          .value?.trim();
        let weightPoundsStr = document
          .querySelector('.form-input[name="weight_pounds"]')
          .value?.trim();
        let ageStr = document.querySelector('.form-input[name="age"]').value?.trim();
        let neck = document.querySelector('input[name="neck"]:checked')?.value;
        let integerPattern = /^\d+$/;

        if (
          !integerPattern.test(heightFeetStr) ||
          heightFeetStr.length > 1 ||
          parseInt(heightFeetStr) <= 0 ||
          !integerPattern.test(heightInchesStr) ||
          parseInt(heightInchesStr) < 0 ||
          parseInt(heightInchesStr) >= 12 ||
          !integerPattern.test(weightPoundsStr) ||
          weightPoundsStr.length > 4 ||
          parseInt(weightPoundsStr) <= 0 ||
          !integerPattern.test(ageStr) ||
          parseInt(ageStr) <= 0
        ) {
          document
            .querySelector('#bmi-form-body')
            .insertAdjacentHTML(
              'beforeend',
              '<div class="form-field bmi-result mt-4" style="color: var(--cpap-text-error-red);">Please fill in all the fields with valid numbers without decimals.</div>'
            );
          return false;
        } else if (!neck) {
          document
            .querySelector('#bmi-form-body')
            .insertAdjacentHTML(
              'beforeend',
              '<div class="form-field bmi-result mt-4" style="color: var(--cpap-text-error-red);">Please choose "Yes" or "No" regarding your neck circumference</div>'
            );
          return false;
        }

        heightFeet = parseFloat(heightFeetStr);
        heightInches = parseFloat(heightInchesStr);
        weightPounds = parseFloat(weightPoundsStr);
        age = parseFloat(ageStr);

        sessionStorage.setItem('birthSex', birthSexStr);
        sessionStorage.setItem('heightFeet', heightFeet);
        sessionStorage.setItem('heightInches', heightInches);
        sessionStorage.setItem('weightPounds', weightPounds);
        sessionStorage.setItem('age', age);
        sessionStorage.setItem('neck', neck);

        return true;
      }

      function bmiFormValuesChanged() {
        const storedHeightFeet = parseFloat(sessionStorage.getItem('heightFeet'));
        const storedHeightInches = parseFloat(sessionStorage.getItem('heightInches'));
        const storedWeightPounds = parseFloat(sessionStorage.getItem('weightPounds'));
        const storedAge = parseFloat(sessionStorage.getItem('age'));
        const storedNeck = sessionStorage.getItem('neck');

        let currentHeightFeet = parseFloat(
          document.querySelector('.form-input[name="height_feet"]').value
        );
        let currentHeightInches = parseFloat(
          document.querySelector('.form-input[name="height_inches"]').value
        );
        let currentWeightPounds = parseFloat(
          document.querySelector('.form-input[name="weight_pounds"]').value
        );
        let currentAge = parseFloat(document.querySelector('.form-input[name="age"]').value);
        let currentNeck = document.querySelector('input[name="neck"]:checked').value;

        return (
          currentHeightFeet !== storedHeightFeet ||
          currentHeightInches !== storedHeightInches ||
          currentWeightPounds !== storedWeightPounds ||
          currentAge !== storedAge ||
          currentNeck !== storedNeck
        );
      }

      const submitButton = document.querySelector(
        '.tabbing-content[data-type="bmiform"] .btn-submit'
      );

      submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        if (!validateBmiForm()) {
          styleFormValidation(false);
          return;
        }

        let totalInches = heightFeet * 12 + heightInches;
        let kilos = weightPounds * 0.453592;
        let meters = parseInt(totalInches) * 0.0254;
        bmi = Number((kilos / (meters * meters)).toFixed(1));
        bmiCount = 0;
        let sexAtBirthPoints = sessionStorage.getItem('birthSex') === 'Male' ? bmiCount++ : 0;
        let neckPoints = sessionStorage.getItem('neck') === 'yes' ? bmiCount++ : 0;
        if (bmi > 30) {
          bmiCount++;
        } else {
          bmiCount--;
        }
        if (age > 49) {
          bmiCount++;
        }

        styleFormValidation(true);
        if (document.querySelector('.bmi-result')) {
          document.querySelector('.bmi-result').remove();
        }
        document.getElementById('tabbing-next').click();
      });

      document
        .querySelector('.tabbing-content[data-type="form"] .btn-submit')
        .addEventListener('click', (e) => {
          e.preventDefault();
          calculateQuizResult(bmiCount);
          calculateProgress();
        });

      document.querySelectorAll('.choose-block').forEach((block) => {
        block.addEventListener('click', () => {
          block
            .closest('.choose-block-main')
            .querySelectorAll('.choose-block')
            .forEach((sibling) => {
              sibling.classList.remove('active');
            });
          block.classList.add('active');
          document.getElementById('tabbing-next').click();
          if (window.cpap.isElementVisible('.error-msg')) {
            document.querySelector('.error-msg').classList.add('hidden');
          }
        });
      });

      function calculateQuizResult(bmiCount) {
        loadDeferredUtiltityFunctions(() => {
          setTimeout(() => {
            document
              .querySelector('.header__icon--cart svg path')
              .setAttribute('fill', 'var(--cpap-primary-white');
            window.cpap.visualEffects.fadeIn('.header-caret-icon');
          }, 1000);

          let resultCount = 0;
          document.querySelectorAll('.choose-block.active').forEach((block) => {
            let count = parseInt(block.getAttribute('data-points'));
            resultCount += count;
          });
          resultCount = resultCount + bmiCount;

          function getRiskLevel(score) {
            const riskLevels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

            if (score >= 8) {
              return riskLevels[9];
            } else if (score >= 0) {
              return riskLevels[score + 1];
            } else {
              return riskLevels[0];
            }
          }

          let riskScore = getRiskLevel(resultCount);
          if (riskScore) {
            document.querySelectorAll('.result-count span').forEach((span) => {
              span.classList.remove('active');
            });
            document
              .querySelector('.result-count span[data-point="' + riskScore + '"]')
              .classList.add('active');
            document.querySelectorAll('.product-blocks').forEach((block) => {
              block.classList.add('cpap__fadeable--hidden');
            });
            document
              .querySelector('.product-blocks[data-point="' + riskScore + '"]')
              .classList.remove('cpap__fadeable--hidden');
            document.querySelectorAll('.tabbing-content').forEach((content) => {
              content.classList.add('cpap__fadeable--hidden');
            });
            setTimeout(() => {
              window.cpap.visualEffects.fadeIn('.tabbing-content[data-type="result"]');
            }, 250);
            document.querySelector('.tabbing-content[data-type="result"] .btn-risk').textContent =
              'Risk level ' + riskScore;

            switch (true) {
              case riskScore <= 3:
                document.querySelector(
                  '.result-message'
                ).innerHTML = `<strong>${window.cpap.singleProductQuiz?.lowRiskWording}</strong>`;
                break;
              case riskScore >= 4 && riskScore <= 7:
                document.querySelector(
                  '.result-message'
                ).innerHTML = `<strong>${window.cpap.singleProductQuiz?.mediumRiskWording}</strong>`;
                break;
              case riskScore >= 8:
                document.querySelector(
                  '.result-message'
                ).innerHTML = `<strong>${window.cpap.singleProductQuiz?.highRiskWording}</strong>`;
                break;
            }
          } else {
            document.querySelectorAll('.tabbing-content').forEach((content) => {
              content.classList.add('cpap__fadeable--hidden');
            });
            document
              .querySelector('.tabbing-content[data-type="result-mask"]')
              ?.classList?.remove('cpap__fadeable--hidden');
            document.querySelector('.tabbing-content[data-type="result"] .btn-risk').textContent =
              'Risk level ' + riskScore;
          }
        });
      }

      function styleFormValidation(bool) {
        let borderStyle;

        if (!bool) {
          borderStyle = '1px solid var(--cpap-text-error-red)';
        } else {
          borderStyle = '1px solid var(--cpap-stroke-gray)';
        }

        document
          .querySelectorAll(
            '.result-form-body .form-field .form-input, .result-form-body .form-field .form-select, .btn-radio'
          )
          .forEach((element) => {
            element.style.border = borderStyle;
          });
      }

      function calculateProgress() {
        setTimeout(() => {
          let current = window.cpap.getFirstVisibleElement('.tabbing-main .tabbing-content');

          let tabs = document.querySelectorAll(
            `.tabbing-main .tabbing-content[data-type="question"],
        .tabbing-main .tabbing-content[data-type="bmiform"],
        .tabbing-main .tabbing-content[data-type="form"]`
          );
          let totalTabs = tabs.length;
          let currentIndex = Array.from(tabs).indexOf(current);
          let progressPercentage = 0;

          if (totalTabs === 0) {
            progressPercentage = 0;
          } else {
            if (progressPercentage >= 100 || current.dataset.type === 'result') {
              progressPercentage = 100;
            } else {
              progressPercentage = Math.ceil((currentIndex / totalTabs) * 100);
            }
          }

          updateProgressBar(progressPercentage);
        }, 500);
      }

      function updateProgressBar(progress) {
        const siteLogo = document.querySelector('.site-logo');
        const progressSpan = document.getElementById('quiz-progress');
        const containerWidth = document.querySelector('.page-width').offsetWidth;

        // 20% width represents 0% progress, leaving 80% width as 0-100% progress range
        let newWidth = containerWidth * (0.2 + 0.8 * (progress / 100));

        if (window.innerWidth <= 690 && newWidth < 127) {
          newWidth = 127;
        }

        loadDeferredUtiltityFunctions(() => {
          if (progress >= 100) {
            window.cpap.visualEffects.fadeOut(progressSpan);
          } else {
            window.cpap.visualEffects.fadeIn(progressSpan);
          }
        });

        siteLogo.style.width = newWidth + 'px';
        progressSpan.textContent = progress + '%';
      }

      function toggleHeaderLogoOrientation() {
        let windowWidth = window.innerWidth;
        let headerLogoSvg = document.getElementById('quiz-header-logo');
        let parentElement = headerLogoSvg.parentElement;

        if (windowWidth <= 1300) {
          parentElement.insertAdjacentHTML(
            'beforeend',
            `<img src="${window.cpap.singleProductQuiz.mobileHeaderLogo}" id="quiz-header-logo">`
          );
          headerLogoSvg.remove();
        } else {
          parentElement.insertAdjacentHTML(
            'beforeend',
            `<img src="${window.cpap.singleProductQuiz.desktopHeaderLogo}" id="quiz-header-logo">`
          );
          headerLogoSvg.remove();
        }
      }
    },
    { priority: 'user-blocking' }
  );
});
